import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FaUserSecret, FaUsers, FaShareAlt } from 'react-icons/fa';
import './CommunityHero.css';

const CommunityHero = () => {
    const { t } = useTranslation();

    return (
        <section className="community-hero">
            <div className="hero-bg-effect">
                <div className="circle circle-1"></div>
                <div className="circle circle-2"></div>
                <div className="circle circle-3"></div>
            </div>

            <div className="hero-container">
                <h1 className="hero-title">
                    {t('community.hero.title').split('Comunidad')[0]}
                    <span className="text-orange">Comunidad</span>
                    <br />
                    <span className="text-orange">Vital</span>
                </h1>

                <p className="hero-subtitle">
                    {t('community.hero.subtitle')}
                </p>

                <Link to="/signup" className="btn-register-join">
                    {t('community.hero.registerBtn')}
                </Link>

                <div className="hero-features">
                    <div className="feature-chip">
                        <FaUserSecret className="feature-icon" />
                        <span>{t('community.hero.chat')}</span>
                    </div>
                    <div className="feature-chip">
                        <FaUsers className="feature-icon" />
                        <span>{t('community.hero.supportGroups')}</span>
                    </div>
                    <div className="feature-chip">
                        <FaShareAlt className="feature-icon" />
                        <span>{t('community.hero.shareExperiences')}</span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CommunityHero;
